import React from 'react'
import { connect } from 'react-redux'
import {  Row, Modal, Button } from 'react-bootstrap'

import DashboardFormControl from '../../../components/DashboardFormControl'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'

import { fetchLicensesByItemId, blockLicensesByNavisionId } from '../../../actions/order-actions'

class OrderBlock extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, license:undefined, showModal: false, message : '', blocked: false }
      }
    
      componentDidMount() {

        if(this.props.query) {
          this.setState({ query: this.props.query })
        }
        if(this.props.results.length) {
          this.setState({ license: this.props.results[0] })
        }
        if(this.props.showModal) {
          this.setState({ showModal: this.props.showModal })
        }
        if(this.props.blocked) {
          this.setState({ blocked: this.props.blocked })
        }
      }

      componentWillUnmount() {
       this.setState({ query: undefined, license:undefined, showModal: false })
      }

      onSearch(query) {
        this.props.fetchLicensesByItemId(query)
      }

      onConfirm(){
        this.setState({showModal: false})
        console.log(this.state.blocked);
        this.props.blockLicensesByNavisionId(this.state.query, !this.state.blocked)
      }

      onCancel(){
        this.setState({showModal: false})
      }

      render() {
        return <div className='content-licenseAdjustDeactivateBefore' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Order blokkeren / deblokkeren" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
              Blokkeer licenties voor order op basis van Nav ID
                </div>
                <DashboardFormControl style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="Zoek order"
                value={this.props.query || this.state.query}
                callback={(query) => this.onSearch(query)}
                />
              </div>
              <div>
                  <Modal show={ this.state.showModal } onHide={ () => this.onCancel() }>
                    <Modal.Header>
                      <Modal.Title>Bevestiging</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <span>{ this.props.message}</span>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button bsStyle='danger' onClick={ () => this.onCancel() } id='cancel'>Annuleren</Button>
                      <Button bsStyle='success' onClick={ () => this.onConfirm() } id='confirm'>Doorgaan</Button>
                    </Modal.Footer>
                  </Modal>
              </div>
          </Row>
          </Row>
        </div>
      }

    
}

  export default connect((state) => { 
    const licenses = state.orders.licenses
    const unblockedLicense = licenses.length ? licenses.find(item => item.blocked === false) : {blocked: false}
    const showModalBool = licenses.length ? true : false;
    const message = showModalBool && unblockedLicense ? 'Wil je de order blokkeren' : 'Wil je de order deblokkeren'
    return { 
    results: state.licenses.searchResults,
    showModal:showModalBool,
    message: message,
    blocked: unblockedLicense ? false : true,
    query:licenses.navID,
   }}, {
    fetchLicensesByItemId,
    blockLicensesByNavisionId
    
  })(OrderBlock)
